import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryAPI } from "./api/queryDetails";
import { queryClient } from "../../shared/providers/QueryProvider";

export const useFetch = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ params }: { params: any }) => {
            return await queryAPI.fetch({ params });
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useFetchStates = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ params }: { params: any }) => {
            return await queryAPI.fetchStates({ params });
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};


export const useCreate = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ payload }: { payload: any }) => {
            return await queryAPI.create({ payload });
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useUpdate = () => {
    const qc = useQueryClient();
    return useMutation({
        mutationFn: async ({ queryId, payload }: { queryId: string, payload: any }) => {
            return await queryAPI.update({ queryId, payload });
        },
        onSuccess: async () => {
            await qc.refetchQueries({ queryKey: ["user-context"] });
        },
    });
};

export const useGetQueryDetails = ({ queryId }: { queryId: string }) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        queryKey: ["query-details", queryId],
        queryFn: () => queryAPI.get({ queryId }),
        enabled: !!queryId,
    });
    return {
        queryDetails: data?.data,
        isPending, isFetching, isError,
        refetch: refetch,
        removeCache: () => { queryClient.removeQueries({ queryKey: ["query-details", queryId] }); }
    }
};